import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ThemeProvider } from "@mui/material";
import { truffleTheme } from "../../Theme";
import { TruffleGradientDefinitions } from "../TruffleGradientDefinitions";
export const TruffleThemeProvider = (props) => (_jsxs(ThemeProvider, { theme: truffleTheme, children: [_jsx(TruffleGradientDefinitions, {}), props.children] }));
//# sourceMappingURL=TruffleThemeProvider.js.map